/** Three little turtles along the bottom of the birthday page.
 *
 *  Same trick as PixelHeart, for the same reason: the art is a grid of
 *  characters you can read in the source and edit by moving one letter, not an
 *  SVG path that nobody will ever touch again. Legend, left to right through
 *  the rows below:
 *
 *      .  nothing      o  outline      s  shell
 *      d  shell spot   g  skin         e  eye
 *
 *  Fourteen wide, eight tall, facing right. At the 44px they render at, a
 *  turtle is roughly three physical pixels per cell on a phone -- which is why
 *  `shape-rendering: crispEdges` matters more here than on the heart: at that
 *  size antialiasing does not soften the edges, it eats them.
 */
const O = "#22381a";   // outline
const S = "#5b8731";   // shell -- the same grass green the Minecraft mode uses
const D = "#3f6323";   // the darker plates on the shell
const G = "#a7d16b";   // head and feet
const E = "#141414";   // eye

export const TURTLE_GRID = [
  "....oooo......",
  "...osssso.....",
  "..osdssdso....",
  ".osssddsssooo.",
  "osdsssssdsogeo",
  "osssssssssoggo",
  ".oooooooooooo.",
  "..ogo....ogo..",
] as const;

const PIXEL: Record<string, string> = { o: O, s: S, d: D, g: G, e: E };

export function PixelTurtle({ className }: { className?: string } = {}) {
  const w = TURTLE_GRID[0].length;
  const h = TURTLE_GRID.length;
  return (
    <svg
      className={["pixelturtle", className].filter(Boolean).join(" ")}
      viewBox={`0 0 ${w} ${h}`}
      shapeRendering="crispEdges"
      aria-hidden="true"
      focusable="false"
    >
      {TURTLE_GRID.flatMap((row, y) =>
        [...row].map((c, x) =>
          PIXEL[c] ? (
            <rect key={`${x}-${y}`} x={x} y={y} width="1" height="1" fill={PIXEL[c]} />
          ) : null,
        ),
      )}
    </svg>
  );
}
